import './App.scss';

import Layout from './components/shared/sections/layout';
import Footer from './components/shared/sections/footer';
import useWindowResize from './custom-hooks/useWindowResize';
import { ScreenProvider } from './context/useScreen';
import { SCREEN_SIZE } from './utils/constant/constant';
import { LoaderProvider } from './context/useLoader';
import Loader from './components/shared/elements/loader';
import useHotjar from './custom-hooks/useHotjar';

function App() {
  // Initialize Hotjar with consent-based loading
  useHotjar();
  
  const {screenDevice} = useWindowResize();
  return (
      <LoaderProvider>
        <div className="App">
          <ScreenProvider>
            <Layout />
            { screenDevice !== SCREEN_SIZE.EXTRA_SMALL_SCREEN && <Footer />}
          </ScreenProvider>
        </div>
        <Loader/>
      </LoaderProvider>
  );
}

export default App;
